/**
 * Another one bites the dust
 */
import PropTypes from 'prop-types';
import EventItem from './EventItem';

export default class WishlistCollageEventList extends React.Component {
  static propTypes = {
    eventName: PropTypes.string,
    regionId: PropTypes.number,
    regionName: PropTypes.string,
    dataRelations: PropTypes.object,
    itemsData: PropTypes.object,
    wishlistId: PropTypes.number,
    wishlistUserId: PropTypes.number,
    wishlistRemoveItemHandler: PropTypes.func,
    wishlistCode: PropTypes.string,
    updateWishlistData: PropTypes.func,
    formatLastDateSaved: PropTypes.func,
    calculateWishlistTotal: PropTypes.func
  };

  constructor() {
    super();
  }

  _querySubCategoryArray = (category) => {
    let allCategoryItems = [];
    const subCategoryKeys = Object.keys(this.props.itemsData[`${this.props.eventName}`][`${category}`]) || [];


    subCategoryKeys.map( (subCategory) => {
      this.props.itemsData[`${this.props.eventName}`][`${category}`][`${subCategory}`].map( (item) => {
        allCategoryItems = [...allCategoryItems, item];
      });
    });

    return allCategoryItems;
  }
  _renderCategoryList = (categoryName) => {
    const items = this._querySubCategoryArray(categoryName);

    return (
      <div className="list-wrapper" key={categoryName}>
        <h6 className="category-list-ttl display-block font-normal">{categoryName}</h6>
        <div className="wishlist-contents">
          {
            items.map((item) => <EventItem itemDetail={ item } wishlistId={ this.props.wishlistId } wishlistUserId={ this.props.wishlistUserId } regionId={ this.props.regionId } regionName={ this.props.regionName } wishlistRemoveItemHandler={ this.props.wishlistRemoveItemHandler } key={ item.wishListItemId } wishlistCode={ this.props.wishlistCode } updateWishlistData={ this.props.updateWishlistData } formatLastDateSaved={ this.props.formatLastDateSaved } calculateWishlistTotal={ this.props.calculateWishlistTotal } />)
          }
        </div>
      </div>
    );
  }
  render() {
    let categories = [];

    if (this.props.itemsData.hasOwnProperty(`${this.props.eventName}`)) {
      categories = Object.keys(this.props.itemsData[`${this.props.eventName}`]);
    }

    return (
      <section className="wishlist-container container">
        <h2 className="event-list-ttl">{this.props.eventName.toLowerCase()}</h2>
        <hr className="semi-transparent-grey-dvdr"/>
        { categories.length > 0 && categories.map( (categoryName) => this._renderCategoryList(categoryName) ) }
        { categories.length === 0 && <span className="display-block no-items-selected">NO ITEMS SELECTED</span> }
      </section>
    );
  }
}
